// CalReportsDatagrid.js
import React from "react";
import { Grid } from "@mui/material";
import { List } from "react-admin";
import useCallReportsExporter from "./CallReportsExporter";
import CallReportsFilter from "./CallReportsFilter";
import CallReportsGrid from "./CallReportsGrid";

const CallReportsDatagrid = ({ filters }) => {
  const { exporter, progressUI } = useCallReportsExporter();

  // Convert your filters to react-admin filter format
  const permanentFilter = React.useMemo(() => {
    const raFilters = {};
    
    if (filters) {
      // Simple key-value pairs that transformFilters will handle
      if (filters.callType) {
        raFilters.callType = filters.callType;
      }
      
      if (filters.disposition) {
        raFilters.disposition = filters.disposition;
      }
      
      if (filters.agentId) {
        raFilters.agentId = filters.agentId;
      }
      
      // Date range - use the exact names transformFilters expects
      if (filters.startDate) {
        raFilters.callDate_gte = filters.startDate;
      }
      if (filters.endDate) {
        raFilters.callDate_lte = filters.endDate;
      }
      
      // If you have a search field in your CallReportsFilter
      if (filters.search) {
        raFilters.q = filters.search;
      }
    }
    
    console.log('Permanent filter to pass to List:', raFilters);
    return raFilters;
  }, [filters]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <List
          resource="call-records"
          filters={<CallReportsFilter />}
          exporter={exporter}
          perPage={25}
          sort={{ field: 'callDate', order: 'DESC' }}
          filter={permanentFilter} // Pass as simple object
          sx={{
            '& .RaList-content': {
              boxShadow: 'none',
              backgroundColor: 'transparent',
            }
          }}
        >
          {progressUI}
          <CallReportsGrid />
        </List>
      </Grid>
    </Grid>
  );
};

export default CallReportsDatagrid;